inputs-checkbox-switch
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label(for="{this.tagScope}_checkbox")
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      div(class="{opts.class}")
        input(type="hidden" value="{ opts.negative_value }" name="{ opts.name }")
        input(if="{opts.positive_value == opts.value}" id="{this.tagScope}_checkbox" type="checkbox" value="{ opts.positive_value }" name="{ opts.name }" checked="checked")
        input(if="{opts.positive_value != opts.value}" id="{this.tagScope}_checkbox" type="checkbox" value="{ opts.positive_value }" name="{ opts.name }")
        label(for="{this.tagScope}_checkbox") { opts.positive_label }
  script(type="typescript").
    this.mixin('inputs.checkbox-switch')
